import { render, staticRenderFns } from "./AuthorRank.vue?vue&type=template&id=a6c43f66&scoped=true&"
import script from "./AuthorRank.vue?vue&type=script&lang=js&"
export * from "./AuthorRank.vue?vue&type=script&lang=js&"
import style0 from "./AuthorRank.vue?vue&type=style&index=0&id=a6c43f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c43f66",
  null
  
)

export default component.exports